// Main JavaScript for Cash'D Website

(function () {
  "use strict";

  // FAQ Accordion
  function initFAQAccordion() {
    const faqItems = document.querySelectorAll("[data-faq-item]");

    faqItems.forEach((item) => {
      const toggle = item.querySelector("[data-faq-toggle]");

      toggle.addEventListener("click", () => {
        const isActive = item.classList.contains("active");

        // Close all other items
        faqItems.forEach((otherItem) => {
          otherItem.classList.remove("active");
        });

        // Toggle current item
        if (!isActive) {
          item.classList.add("active");
        }
      });
    });
  }

  // Smooth Scroll for Navigation Links
  function initSmoothScroll() {
    const navLinks = document.querySelectorAll('a[href^="#"]');

    navLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        const href = link.getAttribute("href");

        // Only handle internal links
        if (href && href.startsWith("#") && href.length > 1) {
          const target = document.querySelector(href);

          if (target) {
            e.preventDefault();

            const navHeight =
              document.querySelector(".hero__nav")?.offsetHeight || 0;
            const targetPosition = target.offsetTop - navHeight;

            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            });
          }
        }
      });
    });
  }

  // Sticky Navigation
  function initStickyNav() {
    const nav = document.querySelector(".hero__nav");
    let lastScroll = 0;

    if (!nav) return;

    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        nav.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.1)";
      } else {
        nav.style.boxShadow = "none";
      }

      lastScroll = currentScroll;
    });
  }

  // Scroll Reveal Animation
  function initScrollReveal() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");

          // Stagger children if container has that class
          if (entry.target.classList.contains("stagger-children")) {
            const children = entry.target.children;
            Array.from(children).forEach((child, index) => {
              setTimeout(() => {
                child.classList.add("active");
              }, index * 100);
            });
          }
        }
      });
    }, observerOptions);

    // Observe sections and reveal elements
    const revealElements = document.querySelectorAll(
      ".reveal, .stagger-children"
    );
    revealElements.forEach((el) => observer.observe(el));
  }

  // Add active state to nav links based on scroll position
  function initActiveNavLinks() {
    const sections = document.querySelectorAll("section[id]");
    const navLinks = document.querySelectorAll(".hero__nav-link");

    if (sections.length === 0 || navLinks.length === 0) return;

    window.addEventListener("scroll", () => {
      let current = "";
      const scrollPosition = window.pageYOffset;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 100;
        const sectionHeight = section.offsetHeight;

        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          current = section.getAttribute("id");
        }
      });

      navLinks.forEach((link) => {
        link.classList.remove("active");
        if (link.getAttribute("href") === `#${current}`) {
          link.classList.add("active");
        }
      });
    });
  }

  // Performance: Debounce function
  function debounce(func, wait = 20, immediate = true) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Initialize all functions when DOM is ready
  function init() {
    initFAQAccordion();
    initSmoothScroll();
    initStickyNav();
    initScrollReveal();
    initActiveNavLinks();

    console.log("Cash'D website initialized!");
  }

  // Run initialization
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
